import React, { useState, useEffect, useRef } from 'react';
import { Item } from '../item';
import cmsUtils from '../../utils/cmsUtils';
import utils from '../../../utils';
import Slider from "react-slick";
import './style.scss';
import { AnimatePresence } from "framer-motion";
import { SiteLink } from '../../../components';

export function FullSizeBannerPanel(props) {
  const item = props.item;
  const subItems = item.items || [];
  const cmsOption = props.cmsOption || {};
  const isMobile = utils.site.isMobile();

  const timer = cmsUtils.payload(item, 'Timer') || 5;
  const anchorPoint = cmsUtils.payload(item, 'AnchorPoint') || '#';

  const [activeIndex, setActiveIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const sliderRef = useRef(null);
  const progressInterval = useRef(null);

  const slides = subItems.map((subItem, index) => (
    <div key={`${subItem.itemId}-${index}`}>
      <AnimatePresence>
        {index === activeIndex && (
          <Item
            item={subItem}
            cmsOption={cmsOption}
          />
        )}
      </AnimatePresence>
    </div>
  ));

  useEffect(() => {
    // Clear any existing interval
    if (progressInterval.current) {
      clearInterval(progressInterval.current);
    }

    // Start new progress animation
    const startTime = Date.now();
    const duration = timer * 1000;

    progressInterval.current = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const newProgress = Math.min((elapsed / duration) * 100, 100);
      setProgress(newProgress);

      if (newProgress >= 100) {
        clearInterval(progressInterval.current);
      }
    }, 50); // Update progress every 50ms for smooth animation

    return () => {
      if (progressInterval.current) {
        clearInterval(progressInterval.current);
      }
    };
  }, [activeIndex, timer]);

  var settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    autoplaySpeed: timer * 1000,
    fade: true,
    autoplay: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
    beforeChange: (current, next) => {
      setActiveIndex(next);
      setProgress(0);
    },
    afterChange: (current) => {
      setActiveIndex(current); // 确保状态同步
    },
    customPaging: (i) => (
      <div
        className="custom-dot"
        onClick={() => {
          if (sliderRef.current) {
            sliderRef.current.slickGoTo(i);
            // setActiveIndex(i);
            // setProgress(0);
          }
        }}
      >
        <div
          className="progress-ring"
          style={{
            background: i === activeIndex
              ? `conic-gradient(white ${progress}%, transparent ${progress}%)`
              : "transparent",
          }}
        ></div>
      </div>
    ),
    appendDots: (dots) => (
      <div
        style={{
          position: "absolute",
          bottom: isMobile ? "15%" : "23%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}>
        <ul style={{ display: "flex", gap: "10px", paddingLeft: "0" }}> {dots} </ul>
      </div>
    )
  };

  const cssClass = utils.classNames('cms_item', 'bannerPanel', 'full-size-container', item.cssClass || item.anchorName || '');

  return (
    <section className='full-size-section'>
      <div className={cssClass} data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName}>
        <
          // @ts-ignore
          Slider {...settings} ref={sliderRef}>
          {slides}
        </Slider>
      </div>
      <SiteLink to={anchorPoint} className="anchor-point">
        <img src='/assets/icons/down-arrow.png' />
      </SiteLink>

    </section>
  );
}